import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { PRODUCT, WEEKDAYS_VN } from "./constants";

dayjs.extend(utc);

export default function ResultCard({ result }) {
  if (!result) return null;

  const draw = /^\d{4}-\d{2}-\d{2}$/.test(String(result.drawDate || ""))
    ? dayjs(result.drawDate)
    : dayjs.utc(result.drawDate);
  const dateLabel = draw.isValid() ? draw.format("DD/MM/YYYY") : "";
  const weekday = draw.isValid() ? WEEKDAYS_VN[draw.day()] : "";
  const numbers = result.numbers || [];

  return (
    <section className="dt123-card">
      <div className="dt123-card__title">
        KẾT QUẢ XỔ SỐ ĐIỆN TOÁN <span className="dt123-card__product">{PRODUCT}</span>
        {dateLabel ? ` - ${dateLabel}` : ""}
      </div>

      <div className="dt123-card__meta">
        Mở thưởng {weekday} ngày {dateLabel}
      </div>

      <ul className="dt123-balls">
        {numbers.map((n, i) => (
          <li key={`${n}-${i}`} className="dt123-ball">
            {n}
          </li>
        ))}
      </ul>
    </section>
  );
}
